import { render } from "./eSesjaTabNavItem.vue?vue&type=template&id=372a73d3"
import script from "./eSesjaTabNavItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./eSesjaTabNavItem.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__